import React, { Component } from 'react';
import {
    Row,
    Col,
    Carousel,
    CarouselIndicators,
    CarouselItem,
    Card,
    CardHeader,
    CardBody,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import banner1 from "../assets/banner/Desktop/banner-1.png"
import banner2 from "../assets/banner/Desktop/banner-2.png"
import banner3 from "../assets/banner/Desktop/banner-3.png"
import banner4 from "../assets/banner/Desktop/SR2030.png"
import banner5 from "../assets/banner/Desktop/banner-5.png"
import banner6 from "../assets/banner/Desktop/banner-6.png"
import banner7 from "../assets/banner/Desktop/so80gbp.png"
import bannerMobile1 from "../assets/banner/Mobile/banner-1.png"
import bannerMobile2 from "../assets/banner/Mobile/banner-2.png"
import bannerMobile3 from "../assets/banner/Mobile/banner-3.png"
import bannerMobile4 from "../assets/banner/Mobile/SR2030.png"
import bannerMobile5 from "../assets/banner/Mobile/banner-5.png"
import bannerMobile6 from "../assets/banner/Mobile/banner-6.png"
import bannerMobile7 from "../assets/banner/Mobile/so80gbp-mobile.png"
import "../css/home.css"
import { BASE_URL } from '../utils/Constants';

export default class Home extends Component {
    constructor() {
        super()
        this.state = {
            activateState: 0,
            buy: "Buy >",
            itemsCarousel: [
                {
                    src: banner1,
                    altText: 'SIMBA 5G',
                    key: '1',
                    url: "/5g"
                },
                {
                    src: banner7,
                    altText: 'SIM-ONLY 200GB',
                    key: '2',
                    url: "/80gb-sim-only-plan-plus"
                },
                {
                    src: banner2,
                    altText: 'SIM-ONLY 100GB',
                    key: '3',
                    url: "/50gb-sim-only-plan"
                },
                {
                    src: banner3,
                    altText: 'SuperRoam MY',
                    key: '4',
                    url: "/130gb-my-sim-only-plan"
                },
                {
                    src: banner4,
                    altText: 'SuperRoam',
                    key: '5',
                    url: "/sr2030-my-sim-only-plan"
                },
                {
                    src: banner5,
                    altText: 'SuperRoam Max',
                    key: '6',
                    url: "/simba-super-roam"
                },
                {
                    src: banner6,
                    altText: 'Broadband',
                    key: '7',
                    url: "/broadband"
                },

            ],
            itemsCarouselMobile: [
  
                {
                    src: bannerMobile1,
                    altText: 'SIMBA 5G',
                    key: '1',
                    url: "/5g"
                },
                {
                    src: bannerMobile7,
                    altText: 'SIM-ONLY 200GB',
                    key: '2',
                    url: "/80gb-sim-only-plan-plus"
                },
                {
                    src: bannerMobile2,
                    altText: 'SIM-ONLY 100GB',
                    key: '3',
                    url: "/50gb-sim-only-plan"
                },
                {
                    src: bannerMobile3,
                    altText: 'SuperRoam MY',
                    key: '4',
                    url: "/130gb-my-sim-only-plan"
                },
                {
                    src: bannerMobile4,
                    altText: 'SuperRoam',
                    key: '5',
                    url: "/sr2030-my-sim-only-plan"
                },
                {
                    src: bannerMobile5,
                    altText: 'SuperRoam Max',
                    key: '6',
                    url: "/simba-super-roam"
                },
                {
                    src: bannerMobile6,
                    altText: 'Broadband',
                    key: '7',
                    url: "/broadband"
                },
            ]
        }
    }

    onClickIndicators(index) {
        this.setState({ activateState: index })
    }

    onPrevSlide() {
        let activate = this.state.activateState
        activate == 0 ? activate = this.state.itemsCarousel.length - 1 : activate--
        this.setState({ activateState: activate })
    }

    onNextSlide() {
        let activate = this.state.activateState
        activate == this.state.itemsCarousel.length - 1 ? activate = 0 : activate++
        this.setState({ activateState: activate })
    }

    renderForWebScreen() {
        return (
            <Carousel
                activeIndex={this.state.activateState}
                interval={5000}
                next={() => this.onNextSlide()}
                previous={() => this.onPrevSlide()}
            >
                <CarouselIndicators
                    activeIndex={this.state.activateState}
                    items={this.state.itemsCarousel}
                    onClickHandler={(i) => this.onClickIndicators(i)}
                />
                {
                    this.state.itemsCarousel.map(e => {
                        return (
                            <CarouselItem>
                                <Link to={e.url}>
                                    <img className='w-100' src={e.src} />
                                </Link>
                            </CarouselItem>
                        )
                    })
                }
                {/* <CarouselControl
                    direction="prev"
                    directionText="Previous"
                    onClickHandler={() => this.onPrevSlide()}
                />
                <CarouselControl
                    direction="next"
                    directionText="Next"
                    onClickHandler={() => this.onNextSlide()}
                /> */}
            </Carousel>
        )
    }

    renderForMobScreen() {
        return (
            <Carousel
                activeIndex={this.state.activateState}
                interval={5000}
                next={() => this.onNextSlide()}
                previous={() => this.onPrevSlide()}
            >
                <CarouselIndicators
                    activeIndex={this.state.activateState}
                    items={this.state.itemsCarouselMobile}
                    onClickHandler={(i) => this.onClickIndicators(i)}
                />
                {
                    this.state.itemsCarouselMobile.map(e => {
                        return (
                            <CarouselItem>
                                <Link to={e.url}>
                                    <img className='d-block w-100' src={e.src} />
                                </Link>
                            </CarouselItem>
                        )
                    })
                }
                {/* <CarouselControl
                    direction="prev"
                    directionText="Previous"
                    onClickHandler={() => this.onPrevSlide()}
                />
                <CarouselControl
                    direction="next"
                    directionText="Next"
                    onClickHandler={() => this.onNextSlide()}
                /> */}
            </Carousel>
        )
    }

    render() {
        const styleDollar = window.innerWidth >= 1000 || window.innerHeight >= 1125 ? { position: "relative", bottom: "0.5em" } : { position: "relative", bottom: "0.7vh" }
        return (
            <div style={{ overflow: "hidden" }}>
                <Row>
                    <Col xs={12}>
                        {
                            window.innerWidth >= 1000 || window.innerHeight >= 1125
                                ? this.renderForWebScreen()
                                : this.renderForMobScreen()
                        }
                    </Col>
                    {/* <Col xs={12}>
                        <UncontrolledCarousel 
                            items={items}
                            controls={window.innerWidth >= 700 ? true : false} 
                            autoPlay
                        />
                    </Col> */}
                </Row>
                <Row className="text-center mb-3" style={{ marginTop: 60 }}>
                    <Col lg={4} sm={12} xs={12}></Col>
                    <Col lg={4} sm={12} xs={12}>
                        <p className="fs-4 fw-light text-center text-dark" style={{ fontFamily: "proxima-nova, sans-serif", fontWeight: 300, fontStyle: "normal", margin: 0 }}>SIMBA Mobile Plan</p>
                        <Link to='/esim' className='fw-semibold fs-5 text-link'>eSIM is available for all SIMBA postpaid plans</Link>
                    </Col>
                    <Col lg={4} sm={12} xs={12}></Col>
                </Row>

                <Row className="text-center" style={{ margin: "auto", display: "flex" }}>
                    {/* SO50GBP Start */}
                    <Col xl={3} lg={6} md={6} sm={12} xs={12} >
                        <Card className="text-center product-card-height mt-2 mb-4" style={{ borderRadius: 20, minWidth: 300, height: 500 }}>
                            <CardHeader className="bg-card-gradient">
                                <Row>
                                    <Col className='mt-2 mb-2'>
                                        <h3 className="text-card-gradient fs-2 mt-2 mb-2">SIM-Only 200GB</h3>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Row className="mt-2">
                                    <Col className="text-desc-product fs-6">
                                        <p>200GB*</p>
                                        <p className='text-decoration-underline text-link-color'><a href='/roaming'>2GB Roaming (Intl)</a></p>
                                        <p>Unlimited Calls to Local Mobile</p>
                                        <p>Free SMS to SIMBA Mobile</p>
                                        <p>500 Local Fixed Line Minutes</p>
                                        <p className='text-decoration-underline text-link-color'><a href="/idd-destinations">300 IDD Mins</a></p>
                                        <p>50 Local SMS</p>
                                        <p disabled style={{ opacity: 0 }} className="noselect">_</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <span className="text-primary dollar-tag" style={styleDollar}>$</span>
                                        <span className="text-primary price-tag">12</span>
                                        <span className="text-primary fw-bold"> /30 days</span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <a href={`${BASE_URL}?selectedOffers=SIMBA_Mobile_SO130GB_Bundle_202402`} className="text-primary px-5 day-tag fs-6 link-buy">{this.state.buy}</a>
                                        <br /><p className="text-dark mt-1" style={{ fontSize: 9, lineHeight: 1 }}><i>* 200GB 1st 6 cycles, 130GB thereafter.</i></p>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                    {/* SO50GBP End */}
                    {/* Sim-Only 100GB Start*/}
                    <Col xl={3} lg={6} md={6} sm={12} xs={12}>
                        <Card className="text-center product-card-height mt-2 mb-4" style={{ borderRadius: 20, minWidth: 300, height: 500 }}>
                            <CardHeader className="bg-card-gradient">
                                <Row>
                                    <Col className='mt-2 mb-2'>
                                        <h3 className="text-card-gradient fs-2 mt-2 mb-2">SIM-Only 100GB</h3>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Row className="mt-2">
                                    <Col className="text-desc-product fs-6">
                                        <p>100GB</p>
                                        <p className='text-decoration-underline text-link-color'><a href='/roaming'>1GB Roaming (Intl)</a></p>
                                        <p>Unlimited Calls to Local Mobile</p>
                                        <p>Free SMS to SIMBA Mobile</p>
                                        <p>300 Local Fixed Line Minutes</p>
                                        <p>30 Local SMS</p>
                                        <p disabled style={{ opacity: 0 }} className="noselect">_</p>
                                    </Col>
                                </Row>
                                <Row className="mb-1 mt-4">
                                    <Col>
                                        <span className="text-primary dollar-tag" style={styleDollar}>$</span>
                                        <span className="text-primary price-tag">10</span>
                                        <span className="text-primary fw-bold"> /30 days</span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <a href={`${BASE_URL}?selectedOffers=TPGSG_Mobile_SO50GB_Bundle_202005`} className="text-primary px-5 day-tag fs-6 link-buy">{this.state.buy}</a>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                    {/* Sim-Only 100GB End*/}
                    {/* SuperRoam 50GB (30D) Start*/}
                    <Col xl={3} lg={6} md={6} sm={12} xs={12}>
                        <Card className="text-center product-card-height mt-2 mb-4" style={{ borderRadius: 20, minWidth: 300, height: 500 }}>
                            <CardHeader className="bg-card-gradient">
                                <Row>
                                    <Col className='mt-2'>
                                        <h3 className="text-card-gradient fs-4">SuperRoam 50GB<br />(30D)</h3>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col className="text-desc-product fs-6">
                                        <p>130GB</p>
                                        <p className='text-decoration-underline text-link-color'><a href="/sr2030-my-sim-only-plan">50GB Roaming (MY)</a></p>
                                        <p className='text-decoration-underline text-link-color'><a href="/sr2030-my-sim-only-plan">10GB Roaming (AU, ID, MY, TH, TW, VN)</a></p>
                                        <p>Unlimited Calls to Local Mobile</p>
                                        <p>Free SMS to SIMBA Mobile</p>
                                        <p>500 Local Fixed Line Minutes</p>
                                        <p className='text-decoration-underline text-link-color'><a href="/idd-destinations">300 IDD Mins</a></p>
                                        <p>50 Local SMS</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <span className="text-primary dollar-tag" style={styleDollar}>$</span>
                                        <span className="text-primary price-tag">20</span>
                                        <span className="text-primary fw-bold"> /30 days</span>
                                    </Col>
                                </Row>
                                <Row className="">
                                    <Col>
                                        <a href={`${BASE_URL}?selectedOffers=TPGSG_Mobile_SuperRoam2030_Bundle_202212`} className="text-primary px-5 day-tag fs-6 link-buy">{this.state.buy}</a>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                    {/* SuperRoam 50GB (30D) End*/}
                    {/* SuperRoam 50GB (90D) Start*/}
                    <Col xl={3} lg={6} md={6} sm={12} xs={12}>
                        <Card className="text-center product-card-height mt-2 mb-4" style={{ borderRadius: 20, minWidth: 300, height: 500 }}>
                            <CardHeader className="bg-card-gradient">
                                <Row>
                                    <Col className='mt-2'>
                                        <h3 className="text-card-gradient fs-4">SuperRoam 50GB<br />(90D)</h3>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col className="text-desc-product fs-6">
                                        <p>130GB</p>
                                        <p className='text-decoration-underline text-link-color'><a href="/sr2030-my-sim-only-plan">50GB Roaming (MY)</a></p>
                                        <p className='text-decoration-underline text-link-color'><a href="/sr2030-my-sim-only-plan">10GB Roaming (AU, ID, MY, TH, TW, VN)</a></p>
                                        <p>Unlimited Calls to Local Mobile</p>
                                        <p>Free SMS to SIMBA Mobile</p>
                                        <p>500 Local Fixed Line Minutes</p>
                                        <p className='text-decoration-underline text-link-color'><a href="/idd-destinations">300 IDD Mins</a></p>
                                        <p>50 Local SMS</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <span className="text-primary dollar-tag" style={styleDollar}>$</span>
                                        <span className="text-primary price-tag">60*</span>
                                        <span className="text-primary fw-bold"> /90 days</span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <a href={`${BASE_URL}?selectedOffers=TPGSG_Mobile_SuperRoam2090_Bundle_202212`} className="text-primary px-5 day-tag fs-6 link-buy">{this.state.buy}</a>
                                        <br /><span className="text-dark" style={{ fontSize: 9 }}><i>* $60 for 90 days. Benefits are renewed every 30 days</i></span>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                    {/* SuperRoam 50GB (90D) End*/}
                    {/* SuperRoam MY Start*/}
                    <Col xl={3} lg={6} md={6} sm={12} xs={12}>
                        <Card className="text-center product-card-height mt-2 mb-4" style={{ borderRadius: 20, minWidth: 300, height: 500 }}>
                            <CardHeader className="bg-card-gradient">
                                <Row>
                                    <Col className='mt-2 mb-2'>
                                        <h3 className="text-card-gradient fs-2 mt-2 mb-2">SuperRoam MY</h3>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Row className="mt-2">
                                    <Col className="text-desc-product fs-6">
                                        <p>130GB</p>
                                        <p className='text-decoration-underline text-link-color'><a href="/130gb-my-sim-only-plan">10GB Roaming (MY)</a></p>
                                        <p>Unlimited Calls to Local Mobile</p>
                                        <p>Free SMS to SIMBA Mobile</p>
                                        <p>500 Local Fixed Line Minutes</p>
                                        <p className='text-decoration-underline text-link-color'><a href="/130gb-my-sim-only-plan">100 Malaysia IDD mins</a></p>
                                        <p>50 Local SMS</p>
                                        <p disabled style={{ opacity: 0 }} className="noselect">_</p>

                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <span className="text-primary dollar-tag" style={styleDollar}>$</span>
                                        <span className="text-primary price-tag">30*</span>
                                        <span className="text-primary fw-bold"> /90 days</span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <a href={`${BASE_URL}?selectedOffers=TPGSG_Mobile_MY130_Bundle_202207`} className="text-primary px-5 day-tag fs-6 link-buy">{this.state.buy}</a>
                                        <br /><p className="text-dark mt-1" style={{ fontSize: 9, lineHeight: 1 }}><i>* $30 for first 90 days. $39 per 90 days thereafter. <br />Benefits are renewed every 30 days</i></p>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                    {/* SuperRoam MY End*/}
                    {/* SuperRoam Max Start*/}
                    <Col xl={3} lg={6} md={6} sm={12} xs={12}>
                        <Card className="text-center product-card-height mt-2 mb-4" style={{ borderRadius: 20, minWidth: 300, height: 500 }}>
                            <CardHeader className="bg-card-gradient">
                                <Row>
                                    <Col className='mt-2 mb-2'>
                                        <h3 className="text-card-gradient fs-2 mt-2 mb-2">SuperRoam Max</h3>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Row className="mt-2">
                                    <Col className="text-desc-product fs-6">
                                        <p>100GB</p>
                                        <p className='text-decoration-underline text-link-color'><a href="/roaming">10GB Roaming Data (Intl + In-flight)</a></p>
                                        <p>Unlimited Calls to Local Mobile</p>
                                        <p>Free SMS to SIMBA Mobile</p>
                                        <p>500 Local Fixed Line Minutes</p>
                                        <p className='text-decoration-underline text-link-color'><a href="/idd-destinations">300 IDD Mins</a></p>
                                        <p>100 Local SMS</p>
                                        <p disabled style={{ opacity: 0 }} className="noselect">_</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <span className="text-primary dollar-tag" style={styleDollar}>$</span>
                                        <span className="text-primary price-tag">25</span>
                                        <span className="text-primary fw-bold"> /30 days</span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <a href={`${BASE_URL}?selectedOffers=TPGSG_Mobile_SR80GB_Bundle_202202`} className="text-primary px-5 day-tag fs-6 link-buy">{this.state.buy}</a>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                    {/* SuperRoam Max End*/}
                    {/* Seniors Plan Start */}
                    <Col xl={3} lg={6} md={6} sm={12} xs={12}>
                        <Card className="text-center product-card-height mt-2 mb-4" style={{ borderRadius: 20, minWidth: 300, height: 500 }}>
                            <CardHeader className="bg-card-gradient">
                                <Row>
                                    <Col className='mt-2 mb-2'>
                                        <h3 className="text-card-gradient fs-2 mt-2 mb-2">Seniors</h3>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Row className="mt-2">
                                    <Col className="text-desc-product fs-6">
                                        <p>20GB</p>
                                        <p className='text-decoration-underline text-link-color'><a href='/roaming'>1GB Roaming (Intl)</a></p>
                                        <p>Unlimited Calls to Local Mobile</p>
                                        <p>Free SMS to SIMBA Mobile</p>
                                        <p>300 Local Fixed Line Minutes</p>
                                        <p>30 Local SMS</p>
                                        <p disabled style={{ opacity: 0 }} className="noselect">_</p>
                                    </Col>
                                </Row>
                                <Row className="mb-1 mt-4">
                                    <Col>
                                        <span className="text-primary dollar-tag" style={styleDollar}>$</span>
                                        <span className="text-primary price-tag">5</span>
                                        <span className="text-primary fw-bold"> /30 days</span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <a href="/seniors-signup-new" className="text-primary px-5 day-tag fs-6 link-buy">{this.state.buy}</a>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                    {/* Seniors Plan End */}
                    {/* Business 50GB Start*/}
                    <Col xl={3} lg={6} md={6} sm={12} xs={12}>
                        <Card className="text-center product-card-height mt-2 mb-4" style={{ borderRadius: 20, minWidth: 300, height: 500 }}>
                            <CardHeader className="bg-card-gradient">
                                <Row>
                                    <Col className='mt-2 mb-2'>
                                        <h3 className="text-card-gradient fs-2 mt-2 mb-2">Business 50GB</h3>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <Row className="mt-2">
                                    <Col className="text-desc-product fs-6">
                                        <p>50GB</p>
                                        <p className='text-decoration-underline text-link-color'><a href='/roaming'>1GB Roaming (Intl)</a> </p>
                                        <p>Unlimited Calls to Local Mobile</p>
                                        <p>Free SMS to SIMBA Mobile</p>
                                        <p>500 Local Fixed Line Minutes</p>
                                        <p>50 Local SMS</p>
                                        <p disabled style={{ opacity: 0 }} className="noselect">_</p>
                                    </Col>
                                </Row>
                                <Row className="mb-1 mt-4">
                                    <Col>
                                        <span className="text-primary dollar-tag" style={styleDollar}>$</span>
                                        <span className="text-primary price-tag">8</span>
                                        <span className="text-primary fw-bold"> /30 days</span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <a href={`${BASE_URL}?selectedOffers=TPGSG_Mobile_BO50GB_Bundle_202109`} className="text-primary px-5 day-tag fs-6 link-buy">{this.state.buy}</a>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                    {/* Business 50GB End*/}
                </Row>
            </div>
        )
    }
}